import React from 'react'
import "./Main_wallet.css"
import Main_wallet_cards_section from './main_wallet_cards_section/Main_wallet_cards_section'
import Main_wallet_cards_banner from './main_wallet_cards_section/main_wallet_cards_banner/Main_wallet_cards_banner'

function Main_wallet() {
    return (
        <>
            <section className='Main_wallet upgraded_menu_sections'>
                <div className="container">

                    <div className="row justify-content-center">
                        <div className="col-md-7">
                            <Main_wallet_cards_banner />
                            <div className="profile_tabs_and_content">
                                <div className="section_holder">
                                    <Main_wallet_cards_section />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Main_wallet